<script setup lang="ts">
    import { computed } from 'vue';
    import type { ChangedFields, Company, Employee } from '@/types';
    import EmployeeChangesGroup from '../EmployeeChangesGroup.vue';

    const props = defineProps<{
        employee: Employee;
        data: ChangedFields;
        optional?: ChangedFields;
        company?: Company;
    }>();

    const values = computed(() => {
        return [
            { name: 'first_name', group: 'personal', key: 'personal' },
            { name: 'last_name', group: 'personal', key: 'personal' },
            { name: 'cpr', group: 'personal', key: 'personal' },
            { name: 'email', group: 'personal', key: 'personal' },
            {
                name: 'company_id',
                group: 'personal',
                key: 'personal',
                oldValue: 'no_change',
                realValue: props.company?.name ?? 'no_change',
                updateValue: 'no_change',
            },
            { name: 'phone_private', group: 'personal', key: 'personal' },
            { name: 'phone_cell', group: 'personal', key: 'personal' },
            { name: 'job_title', group: 'personal', key: 'personal' },
            { name: 'department', group: 'personal', key: 'personal' },
            ...(props.optional &&
            props.optional?.old?.production_unit &&
            props.optional?.attributes?.production_unit &&
            (((props.optional?.old?.production_unit?.value ?? null) !=
                (props.optional?.attributes?.production_unit?.value ?? null) ||
                props.company?.employees_optional?.production_unit) ??
                null)
                ? [{ name: 'production_unit', group: 'optional', key: 'optional' }]
                : []),
        ];
    });
</script>

<template>
    <EmployeeChangesGroup
        :data="data"
        :values="values"
        :employee="employee"
    />
</template>
